import axiosInstance from "../axios";

function getApiErrorMessage(error) {
  const data = error?.response?.data;
  if (!data) return error?.message || "Something went wrong";

  if (typeof data.msg === "string") return data.msg;
  if (typeof data.message === "string") return data.message;

  if (data.msg != null) return JSON.stringify(data.msg);
  if (data.message != null) return JSON.stringify(data.message);

  return error?.message || "Something went wrong";
}

// ─── Global Settings ─────────────────────────────────────────────────────────

export const getReferralSettingsList = async () => {
  try {
    const response = await axiosInstance.post("/refferalSetting/list", {});
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const updateReferralSettings = async (payload) => {
  try {
    const response = await axiosInstance.put("/refferalSetting/update", payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

// ─── Event Configuration (wire in next step) ────────────────────────────────

export const getCategoryEventList = async () => {
  try {
    const response = await axiosInstance.get("/categoryEvent/list");
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const getRewardEventList = async () => {
  try {
    const response = await axiosInstance.post("/rewardEvent/list", {});
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const createRewardEvent = async (payload) => {
  try {
    const response = await axiosInstance.post("/rewardEvent/create", payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const updateRewardEvent = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/rewardEvent/${id}`, payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

// ─── Referral Levels ─────────────────────────────────────────────────────────

export const getReferralLevelList = async () => {
  try {
    const response = await axiosInstance.post("/referralLevel/list", {});
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const createReferralLevel = async (payload) => {
  try {
    const response = await axiosInstance.post("/referralLevel/create", payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

export const updateReferralLevel = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/referralLevel/${id}`, payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

// ─── Audit Log ───────────────────────────────────────────────────────────────

export const getAuditLogList = async (payload = { page: 1, limit: 10 }) => {
  try {
    const response = await axiosInstance.post("/auditLog/list", payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};

// ─── Rewards Analytics ───────────────────────────────────────────────────────

export const getWalletTransactionList = async (payload = {}) => {
  try {
    const response = await axiosInstance.post("/walletTransaction/list/", payload);
    return response;
  } catch (e) {
    return { error: getApiErrorMessage(e) };
  }
};
